import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import './App.css';


function App() {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState('Unsubscribing...');

  useEffect(() => {
    const emailAddress = searchParams.get('emailAddress');
    const client = searchParams.get('client');

    if (emailAddress && client) {
      unsubscribeUser(emailAddress, client);
    } else {
      setMessage('Missing email address or client parameter.');
    }
  }, [searchParams]);

  const unsubscribeUser = async (email, client) => {
    try {
      // Include the extracted client value in the request body
      const requestBody = {
        email,
        client
      };

      const response = await fetch('https://e0y2rz22wb.execute-api.eu-west-2.amazonaws.com/JunoStage/unsubscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      console.log("Received", data);
      const message_obj = JSON.parse(data.body);
      const message = message_obj.message;
      setMessage(message); // Update the message state with the response message
    } catch (error) {
      console.error('Error:', error);
      setMessage('Failed to unsubscribe. Please try again later.');
    }
  };

  return (
    <div className="container">
    <h1>Unsubscribe</h1>
    <p className="message">{message}</p>
  </div>
  );
}

export default App;
